import React from 'react';

export default function WelcomeBanner({ isReturning, streak }) {
  if (!isReturning) return null;

  const streakText = streak > 1 ? ` 🔥 มาต่อเนื่อง ${streak} วัน` : '';

  return (
    <div className="welcome-banner" role="status">
      <span className="welcome-banner__icon">👋</span>
      <p className="welcome-banner__text">
        ยินดีต้อนรับกลับ! ค้นหาต่อจากที่ค้างไว้ได้เลย{streakText}
      </p>
    </div>
  );
}
